<template>
  <v-container class="appTableContainer">
      <v-layout>
        <v-flex>
          <table class="appTable" v-if="!quotedTickets.length">
            <tr>
              <th class="tableTitle description">Description</th>
              <th class="tableTitle item">Item Cost</th>
              <th class="tableTitle item">Quantity</th>
              <th class="tableTitle coverageAmount">Protection Cost</th>
            </tr>
          </table>
          <table class="appTable" v-else>
            <tr>
              <th class="tableTitle description">Description</th>
              <th class="tableTitle item">Item Cost</th>
               <th class="tableTitle item">Quantity</th>
              <th class="tableTitle coverageAmount">Protection Cost</th>
            </tr>
            <tr v-for="ticket in quotedTickets" :key="ticket.id">
              <td class="tableText">{{ ticket.ticketDescription }}</td>
              <td class="tableText costText costQuoteText">
                {{ `${ticket.currency} ${ticket.ticketCost}` }}
              </td>
              <td class="tableText costText costQuoteText">{{ticket.quantity}}</td>
              <td class="tableText coverageText">
         {{ `${ticket.currency} ${(ticket.ticketProtectionCost * ticket.quantity).toFixed(2)}` }}
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'TheTable',
  data: () => ({
    totalTicketInformation: [],
  }),
  props: {
    tickets: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: '$',
    },
    quote: {
      type: Array,
      default: () => [],
    },
    completePolicies: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'recharge',
    },
    quotedTickets: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    tickets(value) {
      this.totalTicketInformation = value;
    },
    quote(value) {
      if (value) {
        this.mergeTicketsAndQuote(value);
      }
    },
  },
  methods: {
    mergeTicketsAndQuote(value) {
      for (let i = 0; i < this.totalTicketInformation.length; i++) { //eslint-disable-line
        this.totalTicketInformation[i] = { ...this.totalTicketInformation[i], ...value[i] };
      }
    },
  },
};
</script>

<style scoped>
.appTableContainer {
  padding-top: 0px;
  padding-bottom: 5px;
}

.tableTitle {
  font-family: Gotham;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #000000;
}

.tableText {
  font-family: Gotham;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.description {
  padding-right: 430px;
}

.item {
  padding-right: 120px;
}

.coverageText {
  text-align: right;
}

 /* Extra large Break Point */
@media screen and (min-width: 1904px) {
  .description {
    padding-right: 626px;
  }
}

 /* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .appTableContainer {
    padding-bottom: 5px;
  }

  .description {
    padding-right: 213px;
  }

  .item {
    padding-right: 45px;
  }
}

 /* Mid Phone to Tablet Break Point */
@media screen and (min-width: 767px) and (max-width: 959px) {
  .description {
    padding-right: 219px;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appTableContainer {
    padding-bottom: 5px;
  }

  .appTable {
    display: block;
    overflow: auto;
  }

  .description {
    padding-right: 170px;
  }


  .item {
    padding-right: 50px;
  }

  .costText {
    position: static;
  }
}
</style>
